import React, { useEffect, useState } from "react";
import "../../styles/job.css";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { Trash2, X } from "lucide-react";

import Select, { SingleValue } from "react-select";

import BreadCrumb from "common/breadcrumb";
import LoadingComponent from "common/components/loader";
import VehicleSearchComponent from "./vehicle-search-component";

import { Service } from "../../models/setup/service";
import { GetProducts, GetPromotions, GetServices, GetServiceTypes } from "api/setup";
import { CreateJob, UpdateJob } from "api/job";

//store
import { useAppDispatch, useAppSelector } from "slices/hook";
import { getCoreDataState } from "slices/core-data/reducer";
import { getAuthState } from "slices/auth/login/reducer";

import { AppUtility } from "utility/app-utility";
import { Customer } from "models/customer/customer";
import { Vehicle } from "models/vehicle/vehicle";
import { LabelValuePair } from "models/label-value";
import { JobStatuses } from "models/settings/branding";
import { AppDispatch } from "slices/store";
import { Job, JobProduct, JobService } from "models/job/job";
import { IJob, IServiceOption } from "./models";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomerSearchParam } from "models/customer/customer-search-param";
import { GetCustomers } from "api/customer";
import { VehicleSearchParam } from "models/vehicle/vehicle-search-param";
import { GetVehicleModels, GetVehicles } from "api/vehicle";
import { taxesGetThunk } from "slices/core-data/thunk";
import { RoutePath } from "routes/route-path";
import { Product } from "models/setup/product";
import { Promotion } from "models/promotion/promotion";

const JobsPage: React.FC = () => {
  const title = "Create a Job";
  const pageTitle = "Job Management";
  const location = useLocation();
  const navigate = useNavigate();
  // Parse the query parameters from the URL
  const searchParams = new URLSearchParams(location.search);
  const cParam = searchParams.get("c");
  const vParam = searchParams.get("v");

  const dispatch: AppDispatch = useAppDispatch();
  const { taxes } = useAppSelector(getCoreDataState);

  const [loading, setLoading] = useState(false);
  const [totalFee, setTotalFee] = useState(0);
  const [totalServiceFee, setTotalServiceFee] = useState(0);
  const [totalProductPrice, setTotalProductPrice] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalPromo, setTotalPromo] = useState(0);

  const [selected, setSelected] = useState<IJob | undefined>();
  const [editMode, setEditMode] = useState(false);

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [validation, setValidation] = useState("");
  const [success, setSuccess] = useState("");

  const [services, setServices] = useState<Service[] | undefined>([]);
  const [allServiceSelectOptions, setAllServiceSelectOptions] = useState<IServiceOption[]>([]);
  const [serviceSelectOptions, setServiceSelectOptions] = useState<IServiceOption[]>([]);
  const [serviceTypes, setServiceTypes] = useState<LabelValuePair[]>([]);

  const { loggedInuser } = useAppSelector(getAuthState);

  const [selectedCustomer, setSelectedCustomer] = useState<Customer | undefined>();
  const [urlCustomer, setUrlCustomer] = useState<Customer | undefined>();

  const [products, setProducts] = useState<Product[] | undefined>([]);
  const [productSelectOptions, setProductSelectOptions] = useState<LabelValuePair[]>([]);

  const [promotions, setPromotions] = useState<Promotion[] | undefined>([]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(taxesGetThunk());
      loadServiceTypes();
      await loadServices();
      await loadProducts();
      await loadPromo();
      if ((cParam ?? "") != "") {
        const _param = {
          customerId: cParam ?? undefined,
        };
        await loadCustomers(_param);
      } else if ((vParam ?? "") != "") {
        const _param = {
          vehicleId: vParam ?? undefined,
        };
        await loadVehicles(_param);
      }
    };

    fetchData();
  }, []);

  const loadServiceTypes = async () => {
    const res = await GetServiceTypes();
    if (!(res?.status?.isError ?? false) && res?.data) {
      let _st = (res?.data ?? []).map((t, index) => ({ value: (t.id ?? 0).toString(), label: t.name ?? "" }));
      if (_st) {
        _st = _st.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      }
      setServiceTypes([{ label: "Any", value: "" }, ..._st]);
    } else {
      setServiceTypes([]);
    }
  };

  const loadCustomers = async (param: CustomerSearchParam) => {
    const res = await GetCustomers(param, undefined, 10, 1);
    if (!(res?.status?.isError ?? false) && res?.data && res?.data?.length > 0) {
      setUrlCustomer(res.data[0]);
      setSelectedCustomer(res.data[0]);
      var _cus = res.data[0];
      if (_cus && _cus.vehicles && _cus.vehicles.length > 0) {
        formik.setFieldValue("referrerCode", _cus.vehicles[0].referrer?.code ?? "");
      }
    }
  };

  const loadVehicles = async (param: VehicleSearchParam) => {
    const res = await GetVehicles(param, undefined, 10, 1);
    if (!(res?.status?.isError ?? false) && res?.data && res?.data?.length > 0) {
      const _cus = res.data[0].currentOwner;
      if (_cus) {
        _cus.vehicles = [{ ...res.data[0], currentOwner: undefined }];
      }
      setUrlCustomer(_cus);
      setSelectedCustomer(_cus);
      if (_cus && _cus.vehicles && _cus.vehicles.length > 0) {
        formik.setFieldValue("referrerCode", _cus.vehicles[0].referrer?.code ?? "");
      }
    }
  };

  const loadServices = async () => {
    //param?: TenantSearchParam
    setLoading(true);
    const param: any = {};
    param["tenantId"] = loggedInuser?.activeTenantId ?? "";

    const res = await GetServices(param);
    if (!(res?.status?.isError ?? false) && res?.data) {
      /*  let _st = (res?.data ?? []).map((t, index) => ({ value: (t.id ?? 0).toString(), label: t.name ?? "" }));
      if (_st) {
        _st = _st.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      } */

      setServices((res?.data ?? []).flatMap((service, index) => [{ ...service }, ...(service.subServices ?? [])]));
      // Flatten service types for the select input
      const _options = (res?.data ?? []).flatMap((service, index) => [
        {
          isSub: false,
          value: (service.id ?? "").toString(),
          //label: service.name ?? "",
          label: `${service.name ?? ""} (${(service.fee ?? 0.0).toFixed(2)})`,
          subOptions: (service.subServices ?? []).map((t, index) => ({
            value: (t.id ?? 0).toString(),
            label: `${t.name ?? ""} (${(t.fee ?? 0.0).toFixed(2)})`,
          })),
          serviceTypeId: (service.serviceType?.id ?? 0).toString(),
        },
        ...(service.subServices ?? []).map((sub) => ({
          isSub: true,
          value: (sub.id ?? "").toString(),
          label: `   ${sub.name ?? ""} (${(sub.fee ?? 0.0).toFixed(2)})`, // Indent the label for display purposes
          serviceTypeId: (service.serviceType?.id ?? 0).toString(),
        })),
      ]);
      /*      console.log(res?.data);
      const _options: any[] = [];
      (res?.data ?? []).forEach((service: Service) => {
        _options.push({
          isSub: false,
          value: (service.id ?? "").toString(),
          label: service.name ?? "",
          subOptions: (service.subServices ?? []).map((t, index) => ({
            value: (t.id ?? 0).toString(),
            label: t.name ?? "",
          })),
        });

        (service.subServices ?? []).forEach((sub) => {
          _options.push({
            isSub: true,
            value: (sub.id ?? "").toString(),
            label: `   ${sub.name ?? ""}`, // Indent the label for display purposes
          });
        });
      }); */

      console.log(_options);
      setServiceSelectOptions(_options);
      setAllServiceSelectOptions([..._options]);
    } else {
      setServices([]);
      setServiceSelectOptions([]);
      setAllServiceSelectOptions([]);
    }
    setLoading(false);
  };

  //Customer

  const onCustomerSelect = (cus?: Customer) => {
    setSelectedCustomer(cus);
  };
  //Services
  // Custom format option label to indent sub-options
  const formatOptionLabel = (option: IServiceOption) => (
    <div>
      <div>{option.label}</div>
      {option.subOptions &&
        option.subOptions.map((sub) => (
          <div key={sub.value} className="ml-4 text-gray-600">
            {sub.label}
          </div>
        ))}
    </div>
  );

  const [addedServices, setAddedServices] = useState<
    {
      service: LabelValuePair;
      price: string;
      taxRate: number;
      taxAmount: number;
      discount: string;
      discountPercentage?: number;
      discountAmount?: number;
      total: string;
    }[]
  >([]);

  const handleAddService = (value: SingleValue<IServiceOption>) => {
    const _exists = addedServices.find((s) => (s.service?.value ?? "") == value!.value);
    if (!_exists) {
      const _selected = services?.find((s) => (s.id ?? "") == value!.value);
      const _tax = taxes.find((t) => t.id == _selected?.tax?.id);
      const _taxRate =
        (_tax?.rates ?? []).length > 0
          ? (_tax?.rates ?? [])
              .sort((a, b) => {
                const dateA = new Date(a.effectiveDate!);
                const dateB = new Date(b.effectiveDate!);

                // Ensure the dates are valid before comparing
                if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
                  return 0; // Return 0 if either date is invalid (to avoid incorrect sorting)
                }

                return dateB.getTime() - dateA.getTime(); // Sort in descending order
              })
              .find((t) => t.isActive && new Date(t.effectiveDate!) <= new Date())?.rate ?? 0
          : 0;

      let _netTot = _selected?.fee ?? 0.0;
      let _disTot =
        (_selected?.discountPercentage ?? 0.0) != 0
          ? _netTot * (_selected?.discountPercentage ?? 0.0) * 0.01
          : _selected?.discountAmount ?? 0.0;
      let _taxTot = (_netTot - _disTot) * (_taxRate / 100);

      setAddedServices([
        ...addedServices,
        {
          service: {
            label: value?.label ?? "",
            value: value?.value ?? "",
          },
          price: (_selected?.fee ?? 0.0).toFixed(2).toString(),
          taxRate: _taxRate,
          taxAmount: _taxTot,
          discountAmount: _selected?.discountAmount,
          discountPercentage: _selected?.discountPercentage,
          discount: _disTot.toFixed(2).toString(),
          total: (_netTot + _taxTot - _disTot).toFixed(2).toString(),
        },
      ]);
    }
  };

  const handleRemoveService = (index: number) => {
    const newServices = addedServices.filter((_, i) => i !== index);
    setAddedServices([...newServices]);
  };

  //Products
  const [addedProducts, setAddedProducts] = useState<
    {
      product: LabelValuePair;
      price: string;
      taxRate: number;
      taxAmount: number;

      discount: string;
      discountPercentage?: number;
      discountAmount?: number;

      qty: number;
      total: string;
    }[]
  >([]);

  const handleAddProduct = (value: LabelValuePair) => {
    const _exists = addedProducts.find((s) => (s.product?.value ?? "") == value.value);
    if (!_exists) {
      const _selected = products?.find((s) => (s.id ?? "") == value.value);
      const _tax = taxes.find((t) => t.id == _selected?.tax?.id);
      const _taxRate =
        (_tax?.rates ?? []).length > 0
          ? (_tax?.rates ?? [])
              .sort((a, b) => {
                const dateA = new Date(a.effectiveDate!);
                const dateB = new Date(b.effectiveDate!);

                // Ensure the dates are valid before comparing
                if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
                  return 0; // Return 0 if either date is invalid (to avoid incorrect sorting)
                }

                return dateB.getTime() - dateA.getTime(); // Sort in descending order
              })
              .find((t) => t.isActive && new Date(t.effectiveDate!) <= new Date())?.rate ?? 0
          : 0;

      let _netTot = _selected?.price ?? 0.0;
      let _disTot =
        (_selected?.discountPercentage ?? 0.0) != 0
          ? _netTot * (_selected?.discountPercentage ?? 0.0) * 0.01
          : _selected?.discountAmount ?? 0.0;

      let _taxTot = (_netTot - _disTot) * (_taxRate / 100);
      setAddedProducts([
        ...addedProducts,
        {
          product: value,
          price: _netTot.toFixed(2).toString(),
          qty: 1,
          taxRate: _taxRate,
          taxAmount: _taxTot,
          discount: _disTot.toFixed(2).toString(),
          discountPercentage: _selected?.discountPercentage,
          discountAmount: _selected?.discountAmount,
          total: (_netTot + _taxTot - _disTot).toFixed(2).toString(),
        },
      ]);
    }
  };

  const handleRemoveProduct = (index: number) => {
    const _newProducts = addedProducts.filter((_, i) => i !== index);
    setAddedProducts([..._newProducts]);
  };

  const loadProducts = async () => {
    setLoading(true);
    const param: any = {};
    // param["tenantId"] = loggedInuser?.activeTenantId ?? "";

    const res = await GetProducts(param);
    if (!(res?.status?.isError ?? false) && res?.data) {
      let _st = (res?.data ?? []).map((t, index) => ({
        value: (t.id ?? 0).toString(),
        label: `${t.name ?? ""} (${(t.price ?? 0.0).toFixed(2)})`,
      }));
      if (_st) {
        _st = _st.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      }
      setProducts(res?.data ?? []);
      setProductSelectOptions(_st);
    } else {
      setProducts([]);
      setProductSelectOptions([]);
    }
    setLoading(false);
  };

  //Promotions
  const loadPromo = async () => {
    setLoading(true);
    const param: any = {};
    // param["tenantId"] = loggedInuser?.activeTenantId ?? "";

    const res = await GetPromotions(param);
    if (!(res?.status?.isError ?? false) && res?.data) {
      setPromotions(res?.data ?? []);
    } else {
      setPromotions([]);
    }
    setLoading(false);
  };

  //Formik
  const handleResetClick = () => {
    setSelected(undefined);
    setEditMode(false);
    formik.setValues({
      name: "",
      isActive: true,
      //  tenant: null,
      serviceType: null,
      parentService: null,
      cost: "",
      fee: "",
      tax: null,

      priorityChargeFixed: "",
      priorityChargePecentage: "",
      isDiscountPercentage: true,

      iconUrl: "",
      estimatedTimeInMinutes: "",

      id: "",
      description: "",
      jobStatus: JobStatuses.find((s) => s.value == "DRAFT"),
      insuranceLetterRequired: false,
      remarks: "",
      remarksForNextService: "",
      warrantyDetails: "",
      mileage: "",
      additionalDiscountAmount: "",

      service: null,
      product: null,
      promoCode: "",
      referrerCode: "",
    }); // Set formik values when prop changes
    setAddedProducts([]);
    setAddedServices([]);
  };
  const formik: any = useFormik({
    initialValues: {
      id: "",
      description: "",
      jobStatus: JobStatuses.find((s) => s.value == "DRAFT"),
      insuranceLetterRequired: false,
      remarks: "",
      remarksForNextService: "",
      warrantyDetails: "",
      mileage: "",
      additionalDiscountAmount: "",
      promoCode: "",
      referrerCode:
        selectedCustomer && selectedCustomer.vehicles && selectedCustomer.vehicles.length > 0
          ? selectedCustomer?.vehicles![0].referrerCode ?? ""
          : "",
      customer: selectedCustomer,
      serviceType: null,
      ...selected, // Spread the fetched selected  data if available
    },
    validationSchema: Yup.object().shape({
      jobStatus: Yup.object()
        .shape({
          label: Yup.string().required(`Job status is required`),
          value: Yup.string(),
        })
        .required(`Job status must be selected`),
      additionalDiscountAmount: AppUtility.formikCurrencyValidtion(),
    }),

    onSubmit: async (values) => {
      try {
        setValidation("");
        if (!selectedCustomer) {
          setValidation("Customer cannot be empty. Please select a customer");
        } else if ((selectedCustomer.vehicles ?? []).length == 0) {
          setValidation(
            "Customer does not have vehicle linked. Please update customer with vehicle details first, or add vehicle for this customer"
          );
        } else {
          setSaving(true);

          var _object: Job = {
            id: selected?.id ?? undefined,
            description: values.description ?? "",
            jobStatusId: values.jobStatus?.value ?? "",
            insuranceLetterRequired: values.insuranceLetterRequired ?? false,
            remarks: values.remarks ?? "",
            remarksForNextService: values.remarksForNextService ?? "",
            warrantyDetails: values.warrantyDetails ?? "",
            mileage: values.mileage ?? "",
            additionalDiscountAmount: values.additionalDiscountAmount
              ? parseFloat(values.additionalDiscountAmount)
              : undefined,
            customer: {},
            vehicle: {},
            services: [],
            products: [],
            promoCode: values.promoCode,
            referrerCode: values.referrerCode,
          };
          if (selectedCustomer) {
            _object.customer!.id = selectedCustomer.id;
            if ((selectedCustomer.vehicles ?? []).length > 0) {
              _object.vehicle!.id = selectedCustomer!.vehicles![0].id;
            }
          }
          if (addedServices.length > 0) {
            _object.services = addedServices.map((a) => {
              return {
                service: {
                  id: parseInt(a.service?.value ?? "0"),
                },
                discountAmount: a.discount ? parseFloat(a.discount ?? 0) : undefined,
                fee: a.price ? parseFloat(a.price ?? 0) : undefined,
              } as JobService;
            });
          }

          if (addedProducts.length > 0) {
            _object.products = addedProducts.map((a) => {
              return {
                product: {
                  id: parseInt(a.product?.value ?? "0"),
                },
                discountAmount: a.discount ? parseFloat(a.discount ?? 0) : undefined,
                unitPrice: (a.price ? parseFloat(a.price ?? 0) : 0) / a.qty,
                quantity: a.qty,
              } as JobProduct;
            });
          }

          const res = (selected?.id ?? 0) == 0 ? await CreateJob(_object) : await UpdateJob(_object);

          if (!(res?.status?.isError ?? false) && (res?.data?.id ?? "") != "") {
            setSuccess("success");
            //formik.resetForm();
            //handleResetClick();
            navigate(`${RoutePath.Admin_Job_edit.replace("/:id", "/" + (res?.data?.id ?? ""))}`);
            /* setSelected({
              id: res?.data?.id ?? "",
              description: res?.data?.description ?? "",
            }); */

            //setEditMode(true);
          } else {
            setError(`error: ${res?.status?.errorCode ?? "500"}:${res?.status?.errorMessage ?? ""}`);
          }
          setTimeout(() => {
            setError("");
            setSuccess("");
          }, 3000);
          setSaving(false);
        }
      } catch (error) {
        setError("Something went wrong...");
        setSaving(false);
      }
    },
  });

  useEffect(() => {
    const _totalServicePrice = addedServices.reduce(
      (sum, service) => sum + parseFloat(service.price ?? "0") + (service.taxAmount ?? 0.0),
      0
    );
    const _totalServiceDiscount = addedServices.reduce((sum, service) => sum + parseFloat(service.discount ?? "0"), 0);
    setTotalServiceFee(_totalServicePrice - _totalServiceDiscount);

    //products
    const _totalProductPrice = addedProducts.reduce(
      (sum, service) => sum + parseFloat(service.price ?? "0") + (service.taxAmount ?? 0.0),
      0
    );
    const _totalProductDiscount = addedProducts.reduce((sum, service) => sum + parseFloat(service.discount ?? "0"), 0);
    setTotalProductPrice(_totalProductPrice - _totalProductDiscount);

    const _additionalDiscount =
      formik.values.additionalDiscountAmount == "" ? 0 : parseFloat(formik.values.additionalDiscountAmount ?? "0");
    setSubTotal(_totalServicePrice + _totalProductPrice);
    setTotalDiscount(_totalServiceDiscount + _totalProductDiscount + _additionalDiscount);

    const _tot =
      _totalServicePrice - _totalServiceDiscount + (_totalProductPrice - _totalProductDiscount) - _additionalDiscount;

    //Promostions
    let _promoTotal = 0.0;
    if ((formik.values.promoCode ?? "") != "") {
      const _promo = promotions?.find(
        (p) => (p.promoCode ?? "").toLowerCase() == (formik.values.promoCode ?? "").toLowerCase()
      );
      if (_promo != null) {
        let _netTotApplicableForPromo = 0;
        if ((_promo.discountPercentage ?? 0) > 0) {
          if (_promo.servicePromo ?? false) {
            _netTotApplicableForPromo = addedServices.reduce(
              (sum, service) => sum + (parseFloat(service.discount ?? "0") == 0 ? parseFloat(service.price ?? "0") : 0),
              0
            );
          }
          if (_promo.productPromo ?? false) {
            _netTotApplicableForPromo =
              _netTotApplicableForPromo +
              addedProducts.reduce(
                (sum, prd) => sum + (parseFloat(prd.discount ?? "0") == 0 ? parseFloat(prd.price ?? "0") : 0),
                0
              );
          }
          _promoTotal = _netTotApplicableForPromo * 0.01 * (_promo.discountPercentage ?? 0);
        } else {
          _promoTotal = _promo.discountAmount ?? 0;
        }
      }
    }
    setTotalPromo(_promoTotal);
    if (_tot > _promoTotal) {
      setTotalFee(_tot - _promoTotal);
    } else {
      setTotalFee(_tot - _promoTotal);
    }
  }, [formik.values.additionalDiscountAmount, addedServices, addedProducts]);

  return (
    <React.Fragment>
      <BreadCrumb title={title} pageTitle={pageTitle} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5 min-w-[50%]">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              {/*  <h6 className="mb-4 text-15"> {(selected?.id ?? "") == "" ? "Create" : "Update"} Job</h6> */}

              <form
                action="#!"
                id="jobForm"
                onSubmit={(event: any) => {
                  event.preventDefault();
                  formik.handleSubmit();
                }}
              >
                <>
                  <VehicleSearchComponent
                    defaultCustomer={urlCustomer}
                    onCustomerSelect={onCustomerSelect}
                  ></VehicleSearchComponent>

                  <div className="grid grid-cols-1 gap-x-5 mt-5">
                    <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
                      <div className="mb-4 xl:col-span-12">
                        <label htmlFor="description" className="inline-block mb-2 text-base font-bold">
                          Description{/*  <span className="text-red-500">*</span> */}
                        </label>
                        <textarea
                          name="description"
                          className="form-textarea w-full rounded-lg border border-gray-300 p-4
                          border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Type your job description here"
                          value={formik.values.description}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          rows={3}
                        />
                        {formik.touched.description && formik.errors.description ? (
                          <p id="error_description" className="mt-1 text-sm text-red-500">
                            {formik.errors.description}
                          </p>
                        ) : null}
                      </div>
                      <div className="mb-4 xl:col-span-4">
                        <label htmlFor="jobStatus" className="inline-block mb-2 text-base font-bold">
                          Status <span className="text-red-500">*</span>
                        </label>
                        <Select
                          className="border-slate-200 focus:outline-none focus:border-custom-500"
                          options={JobStatuses}
                          isSearchable={false} // To disable search
                          name="jobStatus"
                          id="jobStatus"
                          value={formik.values.jobStatus} // Set Formik's `serviceType` value
                          onChange={(option) => formik.setFieldValue("jobStatus", option)} // Update Formik state
                        />
                        {formik.touched.jobStatus && formik.errors.jobStatus ? (
                          <p id="error_jobStatus" className="mt-1 text-sm text-red-500">
                            {formik.errors.jobStatus.label || formik.errors.jobStatus}
                          </p>
                        ) : null}
                      </div>
                      <div className="mb-4 xl:col-span-4">
                        <label htmlFor="mileage" className="inline-block mb-2 text-base font-bold">
                          Mileage
                        </label>
                        <input
                          type="text"
                          name="mileage"
                          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Mileage"
                          value={formik.values.mileage}
                          onChange={formik.handleChange}
                          // Update Formik state
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.mileage && formik.errors.mileage ? (
                          <p id="error_mileage" className="mt-1 text-sm text-red-500">
                            {formik.errors.mileage}
                          </p>
                        ) : null}
                      </div>

                      <div className="mb-4 xl:col-span-4">
                        <label htmlFor="additionalDiscountAmount" className="inline-block mb-2 text-base font-bold">
                          Additional Discount
                        </label>
                        <input
                          type="text"
                          name="additionalDiscountAmount"
                          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Discount"
                          value={formik.values.additionalDiscountAmount}
                          onChange={formik.handleChange}
                          // Update Formik state
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.additionalDiscountAmount && formik.errors.additionalDiscountAmount ? (
                          <p id="error_additionalDiscountAmount" className="mt-1 text-sm text-red-500">
                            {formik.errors.additionalDiscountAmount}
                          </p>
                        ) : null}
                      </div>

                      <div className="mb-4 xl:col-span-4" style={{ display: "none" }}>
                        <label htmlFor="insuranceLetterRequired" className="inline-block mb-2 text-base font-bold">
                          Insurance Letter Required
                        </label>
                        <div className="flex items-center">
                          <div className="relative inline-block w-10 align-middle transition duration-200 ease-in ltr:mr-2 rtl:ml-2">
                            <input
                              type="checkbox"
                              name="insuranceLetterRequired"
                              id="insuranceLetterRequired"
                              className="absolute block size-5 transition duration-300 ease-linear border-2 rounded-full appearance-none cursor-pointer border-slate-200 dark:border-zink-500 bg-white/80 dark:bg-zink-400 peer/published checked:bg-white dark:checked:bg-white ltr:checked:right-0 rtl:checked:left-0 checked:bg-none checked:border-green-500 dark:checked:border-green-500 arrow-none"
                              onChange={formik.handleChange}
                              checked={formik.values.insuranceLetterRequired}
                            />
                            <label
                              htmlFor="insuranceLetterRequired"
                              className="block h-5 font-bold overflow-hidden duration-300 ease-linear border rounded-full cursor-pointer cursor-pointertransition border-slate-200 dark:border-zink-500 bg-slate-200 dark:bg-zink-600 peer-checked/published:bg-green-500 peer-checked/published:border-green-500"
                            ></label>
                          </div>
                        </div>
                      </div>
                      <div className="mb-4 xl:col-span-4">
                        <label htmlFor="promoCode" className="inline-block mb-2 text-base font-bold">
                          Promo Code
                        </label>
                        <input
                          type="text"
                          name="promoCode"
                          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Promo Code"
                          value={formik.values.promoCode}
                          onChange={formik.handleChange}
                          // Update Formik state
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.promoCode && formik.errors.promoCode ? (
                          <p id="error_promoCode" className="mt-1 text-sm text-red-500">
                            {formik.errors.promoCode}
                          </p>
                        ) : null}
                      </div>
                      <div className="mb-4 xl:col-span-4">
                        <label htmlFor="referrerCode" className="inline-block mb-2 text-base font-bold">
                          Referrer Code
                        </label>
                        <input
                          type="text"
                          name="referrerCode"
                          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Referrer Code"
                          value={formik.values.referrerCode}
                          onChange={formik.handleChange}
                          // Update Formik state
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.referrerCode && formik.errors.referrerCode ? (
                          <p id="error_referrerCode" className="mt-1 text-sm text-red-500">
                            {formik.errors.referrerCode}
                          </p>
                        ) : null}
                      </div>

                      <div className="mb-4 xl:col-span-12">
                        <label htmlFor="remarks" className="inline-block mb-2 text-base font-bold">
                          Remarks{/*  <span className="text-red-500">*</span> */}
                        </label>
                        <textarea
                          name="remarks"
                          className="form-textarea w-full rounded-lg border border-gray-300 p-4
                          border-slate-200 dark:border-zink-500 focus:outline-none 
                          focus:border-custom-500 disabled:bg-slate-100 
                          dark:disabled:bg-zink-600 disabled:border-slate-300 
                          dark:disabled:border-zink-500 dark:disabled:text-zink-200 
                          disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 
                          placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Add remarks here"
                          value={formik.values.remarks}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          rows={3}
                        />
                        {formik.touched.remarks && formik.errors.remarks ? (
                          <p id="error_remarks" className="mt-1 text-sm text-red-500">
                            {formik.errors.remarks}
                          </p>
                        ) : null}
                      </div>

                      <div className="mb-4 xl:col-span-12">
                        <label htmlFor="remarksForNextService" className="inline-block mb-2 text-base font-bold">
                          Remarks for Next Service{/*  <span className="text-red-500">*</span> */}
                        </label>
                        <textarea
                          name="remarksForNextService"
                          className="form-textarea w-full rounded-lg border border-gray-300 p-4
                          border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Add remarks here"
                          value={formik.values.remarksForNextService}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          rows={3}
                        />
                        {formik.touched.remarksForNextService && formik.errors.remarksForNextService ? (
                          <p id="error_remarksForNextService" className="mt-1 text-sm text-red-500">
                            {formik.errors.remarksForNextService}
                          </p>
                        ) : null}
                      </div>
                      <div className="mb-4 xl:col-span-12">
                        <label htmlFor="warrantyDetails" className="inline-block mb-2 text-base font-bold">
                          Warranty Details{/*  <span className="text-red-500">*</span> */}
                        </label>
                        <textarea
                          name="warrantyDetails"
                          className="form-textarea w-full rounded-lg border border-gray-300 p-4
                          border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          placeholder="Add warranty details here"
                          value={formik.values.warrantyDetails}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          rows={3}
                        />
                        {formik.touched.warrantyDetails && formik.errors.warrantyDetails ? (
                          <p id="error_warrantyDetails" className="mt-1 text-sm text-red-500">
                            {formik.errors.warrantyDetails}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {/* services */}
                  <div className="rounded-lg border border-gray-300 p-4 shadow-md">
                    <div className="grid grid-cols-1 gap-x-5">
                      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
                        <div className="xl:col-span-12">
                          <label htmlFor="service" className="inline-block mb-4 text-base font-bold">
                            Job Services
                          </label>
                        </div>
                        <div className="xl:col-span-5">
                          <Select
                            className="border-slate-200 focus:outline-none focus:border-custom-500 w-full"
                            options={serviceTypes}
                            isSearchable={true} // To disable search
                            name="serviceType"
                            id="serviceType"
                            /*   formatOptionLabel={formatOptionLabel} */
                            value={formik.values.serviceType} // Set Formik's `serviceType` value
                            onChange={(option: LabelValuePair) => {
                              formik.setFieldValue("serviceType", option);
                              if ((option?.value ?? "") == "") {
                                setServiceSelectOptions([...allServiceSelectOptions]);
                              } else {
                                const _options = allServiceSelectOptions.filter(
                                  (s) => s.serviceTypeId == (option?.value ?? "")
                                );
                                setServiceSelectOptions([..._options]);
                              }
                            }} // Update Formik state
                          />
                        </div>
                        <div className="xl:col-span-5">
                          <Select
                            className="border-slate-200 focus:outline-none focus:border-custom-500 w-full"
                            options={serviceSelectOptions}
                            isSearchable={true} // To disable search
                            name="service"
                            id="service"
                            formatOptionLabel={(option) => (
                              <div
                                className={option.isSub ? "sub-option-class" : ""}
                                style={{ paddingLeft: option.isSub ? "20px" : "0px" }}
                              >
                                {option.label}
                              </div>
                            )}
                            value={formik.values.service} // Set Formik's `serviceType` value
                            onChange={(option) => handleAddService(option)} // Update Formik state
                          />
                        </div>
                        {/*  <div className="xl:col-span-6">
                          <button
                            type="button"
                            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                          >
                            Add Service
                          </button>
                        </div> */}
                      </div>
                    </div>
                    {/* Added Services Section */}
                    <div className="grid grid-cols-1 gap-x-5 mt-4">
                      {(addedServices ?? []).map((service, index) => (
                        <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-2 items-center">
                          <span className="lg:col-span-3">{service.service.label}</span>
                          <div className="lg:col-span-2 flex flex-row">
                            <label htmlFor={`price_${index}`} className="inline-block m-2 text-sm w-[40%]">
                              Fee
                            </label>
                            <input
                              name={`price_${index}`}
                              type="text"
                              placeholder="Price"
                              value={service.price}
                              onChange={(e) => {
                                const updatedServices = [...addedServices];
                                updatedServices[index].price = (
                                  e.target.value === "" ? 0.0 : parseFloat(e.target.value)
                                )
                                  // .toFixed(2)
                                  .toString();

                                let _netTot = e.target.value === "" ? 0.0 : parseFloat(e.target.value);

                                let _disTot =
                                  (updatedServices[index]?.discountPercentage ?? 0.0) != 0
                                    ? _netTot * (updatedServices[index]?.discountPercentage ?? 0.0) * 0.01
                                    : (updatedServices[index]?.discount ?? "") == ""
                                    ? 0.0
                                    : parseFloat(updatedServices[index]?.discount);
                                let _taxTot = (_netTot - _disTot) * (updatedServices[index].taxRate / 100);

                                updatedServices[index].taxAmount = _taxTot;
                                (updatedServices[index].discount = _disTot.toFixed(2).toString()),
                                  (updatedServices[index].total = (_netTot + _taxTot - _disTot).toFixed(2).toString()),
                                  setAddedServices(updatedServices);
                              }}
                              className="border rounded p-1 text-right w-full"
                            />
                          </div>
                          <div className="lg:col-span-2 flex flex-row">
                            <label htmlFor={`discount_${index}`} className="inline-block m-2 text-sm w-[40%]">
                              Discount
                            </label>
                            <input
                              name={`discount_${index}`}
                              type="text"
                              placeholder="Discount"
                              value={service.discount}
                              disabled={(service.discountPercentage ?? 0) != 0}
                              onChange={(e) => {
                                if ((service.discountPercentage ?? 0) == 0) {
                                  const updatedServices = [...addedServices];
                                  updatedServices[index].discount = (
                                    e.target.value === "" ? 0.0 : parseFloat(e.target.value)
                                  )
                                    // .toFixed(2)
                                    .toString();

                                  let _netTot = parseFloat(updatedServices[index].price);
                                  let _disTot = e.target.value === "" ? 0.0 : parseFloat(e.target.value);
                                  let _taxTot = (_netTot - _disTot) * (updatedServices[index].taxRate / 100);

                                  updatedServices[index].taxAmount = _taxTot;
                                  // (updatedServices[index].discount = _disTot.toFixed(2).toString()),
                                  (updatedServices[index].total = (_netTot + _taxTot - _disTot).toFixed(2).toString()),
                                    setAddedServices(updatedServices);
                                }
                              }}
                              className="border rounded p-1 text-right w-full"
                            />
                          </div>
                          <div className="lg:col-span-2">
                            <label htmlFor={`price_tax_${index}`} className="inline-block m-4  text-sm">
                              Tax : {(service.taxAmount ?? 0).toFixed(2)}
                            </label>
                          </div>
                          <div className="lg:col-span-2">
                            <label htmlFor={`price_total_${index}`} className="inline-block m-4  text-sm">
                              Total : {service.total ?? "0.00"}
                            </label>
                          </div>
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={() => handleRemoveService(index)}
                              className="text-red-500 lg:col-span-1"
                            >
                              <div className="flex flex-row">
                                <Trash2 />
                                {/*  <span className="p-1">Remove</span> */}
                              </div>
                            </button>
                          </div>
                          {/*  Line separator visible only on md and smaller screens  For large screens and larger ( lg, xl), the line separator will be hidden. */}
                          {addedServices.length - 1 != index && (
                            <div className="lg:hidden border-t border-gray-300 my-4"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 mt-5 font-bold">
                    Total Service Fee: {AppUtility.FormattedPrice(totalServiceFee)}
                  </div>

                  {/* products */}
                  <div className="rounded-lg border border-gray-300 p-4 shadow-md">
                    <div className="grid grid-cols-1 gap-x-5">
                      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
                        <div className="xl:col-span-12">
                          <label htmlFor="product" className="inline-block mb-4 text-base font-bold">
                            Products/Parts
                          </label>
                        </div>
                        <div className="xl:col-span-10">
                          <Select
                            className="border-slate-200 focus:outline-none focus:border-custom-500"
                            options={productSelectOptions}
                            isSearchable={true} // To disable search
                            name="product"
                            id="product"
                            /*   formatOptionLabel={formatOptionLabel} */
                            value={formik.values.product}
                            onChange={(option) => handleAddProduct(option)} // Update Formik state
                          />
                        </div>
                        {/*  <div className="xl:col-span-6">
                          <button
                            type="button"
                            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                          >
                            Add Service
                          </button>
                        </div> */}
                      </div>
                    </div>
                    {/* Added Products Section */}
                    <div className="grid grid-cols-1 gap-x-5 mt-4">
                      {(addedProducts ?? []).map((product, index) => (
                        <div key={index} className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-2 items-center">
                          <span className="lg:col-span-3">{product.product.label}</span>

                          <div className="lg:col-span-2 flex flex-row">
                            <label htmlFor={`p_qty_${index}`} className="inline-block m-2 text-sm w-[40%]">
                              Quantity
                            </label>
                            <input
                              name={`p_qty_${index}`}
                              type="number"
                              placeholder="Quantity"
                              min={1}
                              value={product.qty}
                              onChange={(e) => {
                                const updatedProducts = [...addedProducts];
                                let _unitPrice = parseFloat(updatedProducts[index].price) / updatedProducts[index].qty;
                                let _unitDiscount =
                                  parseFloat(updatedProducts[index].discount ?? 0) / updatedProducts[index].qty;

                                updatedProducts[index].qty = e.target.value == "" ? 1 : parseFloat(e.target.value);

                                let _netTot = _unitPrice * updatedProducts[index].qty;
                                let _disTot =
                                  (updatedProducts[index]?.discountPercentage ?? 0.0) != 0
                                    ? _netTot * (updatedProducts[index]?.discountPercentage ?? 0.0) * 0.01
                                    : (updatedProducts[index]?.discount ?? "") == ""
                                    ? 0.0
                                    : _unitDiscount * updatedProducts[index].qty;

                                let _taxTot = (_netTot - _disTot) * (updatedProducts[index].taxRate / 100);
                                updatedProducts[index].price = _netTot.toFixed(2);
                                updatedProducts[index].taxAmount = _taxTot;
                                updatedProducts[index].discount = _disTot.toFixed(2);
                                updatedProducts[index].total = (_netTot - _disTot + _taxTot).toFixed(2);
                                setAddedProducts(updatedProducts);
                              }}
                              className="border rounded p-1 text-right w-full"
                            />
                          </div>

                          <div className="lg:col-span-2 flex flex-row">
                            <label htmlFor={`p_price_${index}`} className="inline-block m-2 text-sm w-[40%]">
                              Price
                            </label>
                            <input
                              name={`p_price_${index}`}
                              type="text"
                              placeholder="Price"
                              value={product.price}
                              onChange={(e) => {
                                const updatedProducts = [...addedProducts];
                                updatedProducts[index].price = (
                                  e.target.value === "" ? 0.0 : parseFloat(e.target.value)
                                )
                                  // .toFixed(2)
                                  .toString();
                                let _netTot = e.target.value === "" ? 0.0 : parseFloat(e.target.value);
                                let _disTot =
                                  (updatedProducts[index]?.discountPercentage ?? 0.0) != 0
                                    ? _netTot * (updatedProducts[index]?.discountPercentage ?? 0.0) * 0.01
                                    : (updatedProducts[index]?.discount ?? "") == ""
                                    ? 0.0
                                    : parseFloat(updatedProducts[index]?.discount);

                                let _taxTot = (_netTot - _disTot) * (updatedProducts[index].taxRate / 100);

                                updatedProducts[index].taxAmount = _taxTot;
                                updatedProducts[index].discount = _disTot.toFixed(2);
                                updatedProducts[index].total = (_netTot - _disTot + _taxTot).toFixed(2);
                                setAddedProducts(updatedProducts);
                              }}
                              className="border rounded p-1 text-right w-full"
                            />
                            {/*   <label htmlFor={`p_price_tax_${index}`} className="inline-block m-4 text-base text-sm">
                              Tax : {(product.taxAmount ?? 0).toFixed(2)}
                            </label> */}
                          </div>

                          <div className="lg:col-span-2 flex flex-row">
                            <label htmlFor={`p_discount_${index}`} className="inline-block m-2 text-sm w-[40%]">
                              Discount
                            </label>
                            <input
                              name={`p_discount_${index}`}
                              type="text"
                              placeholder="Discount"
                              value={product.discount}
                              disabled={(product.discountPercentage ?? 0) != 0}
                              onChange={(e) => {
                                if ((product.discountPercentage ?? 0) == 0) {
                                  const updatedProducts = [...addedProducts];
                                  updatedProducts[index].discount = (
                                    e.target.value === "" ? 0.0 : parseFloat(e.target.value)
                                  )
                                    //  .toFixed(2)
                                    .toString();
                                  let _netTot = parseFloat(updatedProducts[index].price);
                                  let _disTot = e.target.value === "" ? 0.0 : parseFloat(e.target.value);
                                  let _taxTot = (_netTot - _disTot) * (updatedProducts[index].taxRate / 100);

                                  updatedProducts[index].taxAmount = _taxTot;
                                  // (updatedServices[index].discount = _disTot.toFixed(2).toString()),
                                  (updatedProducts[index].total = (_netTot + _taxTot - _disTot).toFixed(2).toString()),
                                    setAddedProducts(updatedProducts);
                                }
                              }}
                              className="border rounded p-1 text-right w-full"
                            />
                          </div>
                          <div className="lg:col-span-2">
                            <label htmlFor={`p_price_total_${index}`} className="inline-block m-4 text-sm">
                              Total : {product.total ?? "0.00"}
                            </label>
                          </div>
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={() => handleRemoveProduct(index)}
                              className="text-red-500 lg:col-span-1"
                            >
                              <div className="flex flex-row">
                                <Trash2 />
                                {/*  <span className="p-1">Remove</span> */}
                              </div>
                            </button>
                          </div>
                          {/*  Line separator visible only on md and smaller screens  For large screens and larger ( lg, xl), the line separator will be hidden. */}
                          {addedProducts.length - 1 != index && (
                            <div className="lg:hidden border-t border-gray-300 my-4"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 mt-5 font-bold">
                    Total Products/Parts Price: {AppUtility.FormattedPrice(totalProductPrice)}
                  </div>

                  <div className="grid grid-cols-[2fr_1fr] gap-4 mt-7">
                    <div className="flex justify-end font-bold text-lg">Sub Total:</div>
                    <div className="flex justify-end font-bold text-lg ">{AppUtility.FormattedPrice(subTotal)}</div>

                    <div className="flex justify-end font-bold text-lg">Total Discount:</div>
                    <div className="flex justify-end font-bold text-lg">{AppUtility.FormattedPrice(totalDiscount)}</div>

                    <div className="flex justify-end font-bold text-lg">Total Promo:</div>
                    <div className="flex justify-end font-bold text-lg">{AppUtility.FormattedPrice(totalPromo)}</div>

                    <div className="flex justify-end font-bold text-lg">Total:</div>
                    <div className="flex justify-end font-bold text-lg">{AppUtility.FormattedPrice(totalFee)}</div>
                  </div>

                  <div className="flex justify-end gap-2 mt-5">
                    <button
                      type="button"
                      onClick={handleResetClick}
                      className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                    >
                      <X className="inline-block size-4" />
                      <span className="align-middle">Cancel</span>
                    </button>
                    {(selected?.id ?? "") == "" && (
                      <button
                        type="submit"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        {(selected?.id ?? "") == "" ? "Create" : "Update"}
                      </button>
                    )}
                    {(selected?.id ?? "") != "" && (
                      <button
                        type="button"
                        onClick={() => {
                          navigate(`${RoutePath.Admin_Job_edit.replace("/:id", "/" + selected?.id)}`);
                        }}
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </>
              </form>
              {loading && <LoadingComponent />}
              {saving && <LoadingComponent />}
              {success && (
                <div
                  className="px-4 py-3 mt-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                  id="successAlert"
                >
                  <b>Success! </b>
                  {<>job has been {!editMode ? "added" : "updated"} successfully</>}
                </div>
              )}
              {validation && (
                <div
                  className="px-4 py-3 mt-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                  id="successAlert"
                >
                  <>{validation}</>
                </div>
              )}
              {error && (
                <div
                  className="px-4 py-3 mt-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                  id="successAlert"
                >
                  <>
                    Oops! Something went wrong while attempting to {!editMode ? "create" : "update"} job. Please try
                    again later or contact support for assistance.
                  </>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default JobsPage;
